import classNames from "classnames";
import classes from "../SuccessorNotification/SuccessorNotification.module.less";
import { getProductData } from "~/models/ProductData";
import { CardTag } from "~/ProductDetails/components/PhaseInOut/CardTag/CardTag";
import { getPrimaryImage } from "~/utils/product/getPrimaryImage";
import { ImageFormat } from "~/dto/ProductDataDTO";
import { Trans, useTranslation } from "react-i18next";
import { type AlternativeBannerContext } from "~/ProductDetails/components/PhaseInOut/usePhaseInOutLogic";
import CenterContents from "~/common/components/CenterContents";
import CircleSpinner from "~/common/components/CircleSpinner/CircleSpinner";
import { usePurchasePlace } from "~/feature/Analytics/ga/recommendations/RecommendationContexts";
import type { PurchaseType } from "~/feature/Analytics/ga/recommendations/types";
import { appendPurchaseParams } from "~/ProductDetails/components/ProductSummary/PdpSummaryHelper";

interface Props {
  className?: string;
  data: AlternativeBannerContext;
}

export const AlternativeNotification = (props: Props) => {
  const { t } = useTranslation();
  const reco_place = usePurchasePlace();
  const reco_type: PurchaseType = "ap";

  if (props.data.status !== "loaded") {
    return (
      <CenterContents className={classNames(props.className)}>
        <CircleSpinner />
      </CenterContents>
    );
  }
  const alternative = getProductData(props.data.product);
  const designation = alternative.designation;
  const tagLabel = t(`page.pdp.phaseinout.alternative.tag`);
  const pdpUrl = appendPurchaseParams(alternative.url, reco_place, reco_type);
  return (
    <a
      tracking-aux-aspr-type={"Alternative"}
      tracking-aux-aspr-name={alternative.designation}
      tracking-aux-aspr-id={alternative.code}
      href={pdpUrl}
      className={classNames(classes.root, props.className)}
    >
      <CardTag className={classNames(classes.tag, classes.tagAlternative)}>{tagLabel}</CardTag>
      <div className={classes.content}>
        <div className={classes.imageSection}>
          <img
            className={classes.boxImage}
            src={getPrimaryImage(alternative.images, { imageFormat: ImageFormat.product })?.url ?? ""}
            alt={""}
          />
        </div>
        <div className={classes.text}>
          <p className={classNames(classes.headline, classes.headlineBig)}>
            <Trans i18nKey={"page.pdp.phaseinout.alternative.headline"}>
              Alternative version {{ designation }} is available!
            </Trans>
          </p>
          <p className={classes.description}>
            <Trans i18nKey={"page.pdp.phaseinout.alternative.description"}>
              We invite you to switch to the <b>alternative version of this product: </b>
              <span className={classes.pseudoLink}>{{ designation }}</span>, which you can buy now.
            </Trans>
          </p>
        </div>
      </div>
    </a>
  );
};
